module.exports = __webpack_public_path__ + "img/BE.ea3f348f.svg";